import $ from 'jquery';

class MaRSMomentums {

  //describe and create/initiate object
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".momentumVentures__Results");
    this.showButton = $(".momentumVentures__link");
    this.filterSelect = $(".momentumVentures__filter-child li");
    this.searchField = $("#momentum-search");
    this.loadMoreButton = $(".momentumVentures__load a");
    this.postsPerPage = 12;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  //events
  events() {
    $(document).on("click", ".momentumVentures__link", this.openDetailsOverlay.bind(this));
    $(document).on("click", ".momentumVentures__close", this.closeDetailsOverlay.bind(this));
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.filterSelect.on("click", this.filterLogic.bind(this));
  }

  //methods (function, action...)
  openDetailsOverlay(e) {
    this.screenWidth = $(window).width();
    if (this.screenWidth < 768) {
      e.preventDefault();
      let target = e.currentTarget;
      let link = $(".momentumVentures__extlink", target).attr("data-href");

      if ($(this)) {
        let contents = $('.momentumVentures__Description', target).html();
        this.body.prepend(`<div class="momentumVentures__details-wrapper opened"><div class="momentumVentures__close"></div>${contents}</div>`);
        this.body.addClass("body-no-scroll");

        let $span = $('.momentumVentures__details-wrapper.opened span');
        $span.replaceWith(function () {
          return $('<a/>', {
            href: link,
            class: 'momentumVentures__extlink',
            html: this.innerHTML,
            target: "_blank"
          });
        });
        this.isOverlayOpen = true;
      }
    }
  }


  closeDetailsOverlay() {
    this.isOverlayOpen = false;
    $('.opened').remove();
    $('body').removeClass("body-no-scroll");
  }


  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);
      $(".momentumVentures__filter-list.mtoggle li.active span").html($(".momentumVentures__filter-list.mtoggle li.active span").attr("data-hold") );

      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }


  filterLogic(e) {
    if ($(this)) {
      let target, slug = e.target;
      target = slug.getAttribute('data-text');
      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getProgramResults(target), 750);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getProgramResults(target), 750);
        this.isSpinnerVisible = true;
      }
    }
  }


  getResults() {
    if ($(".momentumVentures__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/momentum?term=' + this.searchField.val() + '&page=1', (results) => {

        let currentPage = results.current_page;

        this.resultsDiv.html(`
            ${results.ventureInfo.length ? '<div class="row no-gutters momentumVentures__row">' : '<p>No Venture information matches the search term.</p>'}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 momentumVentures__link" target="_blank">
                <img class="momentumVentures__logo" src="${item.company_logo}">
                
                <div class="momentumVentures__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p>
                  <span data-href="${item.company_url}" class="momentumVentures__extlink" target="_blank">View company website</span>
                </div>
               
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>
      `);
        this.isSpinnerVisible = false;
        this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`) : '';
        `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getProgramResults(programValue) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/momentum?program=' + programValue + '&page=1', (results) => {

      let currentPage = results.current_page;

      this.resultsDiv.html(`
            ${results.ventureInfo.length ? '<div class="row no-gutters momentumVentures__row">' : '<p>No Venture information matches the search term.</p>'}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 momentumVentures__link" target="_blank">
                <img class="momentumVentures__logo" src="${item.company_logo}">
                
                <div class="momentumVentures__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p>
                  <span data-href="${item.company_url}" class="momentumVentures__extlink" target="_blank">View company website</span>
                </div>
               
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>     
      `);
      this.isSpinnerVisible = false;
      programValue ? this.loadMoreButton.attr("data-url", `program=${programValue}&page=2`) : this.loadMoreButton.attr("data-url", `term=${programValue}&page=2`);
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }


  LoadActiveResults() {

    if ($(".momentumVentures__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/momentum?program=&page=1', (results) => {

        let currentPage = results.current_page;

        this.resultsDiv.html(`
   
            ${results.ventureInfo.length ? '<div class="row no-gutters momentumVentures__row">' : '<p>No Venture information matches the search term.</p>'}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 momentumVentures__link" target="_blank">
                <img class="momentumVentures__logo" src="${item.company_logo}">
                
                <div class="momentumVentures__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p>
                  <span data-href="${item.company_url}" class="momentumVentures__extlink" target="_blank">View company website</span>
                </div>
               
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>
       
      `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
        `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let currentProgram = this.loadInfo.split('=');
    currentProgram = currentProgram[1].split('&');

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/momentum?' + this.loadInfo, (results) => {

      let currentPage = results.current_page;

      this.resultsDiv.append(`
            ${results.ventureInfo.length ? '<div class="row no-gutters momentumVentures__row">' : ''}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 momentumVentures__link" target="_blank">
                <img class="momentumVentures__logo" src="${item.company_logo}">
                
                <div class="momentumVentures__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p>
                  <span data-href="${item.company_url}" class="momentumVentures__extlink" target="_blank">View company website</span>
                </div>         
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>  
      `);
      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      if ( this.searchField.val().length > 1 ) {
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      }
      else {
        this.loadMoreButton.attr("data-url", `program=${currentProgram[0]}&page=${parseInt(currentPage) + 1}`);
      }
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default MaRSMomentums;